module.exports = __webpack_public_path__ + "static/media/shop-01.df8c8d6d.jpg";